import { ConstitutionExcelRawRow } from '../types/ConstitutionExcel';

const formatKeyForReplaceAccents = (key: string): string => {
  if (!key) return '';
  return key
    ?.normalize('NFD')
    ?.replace(/[\u0300-\u036f]/g, '')
    ?.toUpperCase();
};

export const mapExcelKeysToUppercase = (
  objectsList: ConstitutionExcelRawRow[]
): ConstitutionExcelRawRow[] => {
  if (!objectsList?.length) return [];

  return objectsList.map((object) => {
    const newObject: ConstitutionExcelRawRow = {};
    Object.keys(object).forEach((key) => {
      const formattedKey = formatKeyForReplaceAccents(key);
      newObject[formattedKey] = object[key];
    });
    return newObject;
  });
};
